module.exports = __webpack_public_path__ + "assets/players-active.53ed244b.svg";